module.exports = __webpack_public_path__ + "static/media/searchpink.68366660.svg";